module.exports = __webpack_public_path__ + "img/imgs-3.511d370b.png";